var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.373,
    height: 19.37,
    fill: "none",
    viewBox: "0 0 18.373 19.37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.373 0v6.408h-6.408",
    "data-name": "Path 16230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.937 14.222a8.543 8.543 0 1 1 .244-8.36",
    "data-name": "Path 16231"
  }))));
};
export { SvgCircleArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOC4zNzMiIGhlaWdodD0iMTkuMzciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxOC4zNzMgMTkuMzciPgogIDxnIGlkPSJHcm91cF8yNjc4IiBkYXRhLW5hbWU9Ikdyb3VwIDI2NzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzE2MjMwIiBkYXRhLW5hbWU9IlBhdGggMTYyMzAiIGQ9Ik0yNTMuNDA4LDIxMXY2LjQwOEgyNDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMzcuMDM1IC0yMTEpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzE2MjMxIiBkYXRhLW5hbWU9IlBhdGggMTYyMzEiIGQ9Ik0yMzYuOTM3LDIyNi45NGE4LjU0Myw4LjU0MywwLDEsMSwuMjQ0LTguMzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yMjEgLTIxMi43MTgpIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz4KICA8L2c+Cjwvc3ZnPgo=";